import api from '../api';

const listSdg = query => api.get('/api/sdgs/', { params: query });

export default {
  listSdg,
};
